import React from 'react'
import * as UI from 'ui'
import { Translation } from '@morningtrain/react-translations'

function GuestCountChartTooltipInner (props) {
  if (!props) {
    return null
  }

  const thisPeriod = !isNaN(parseFloat(props.this_period)) ? parseFloat(props.this_period) : 0
  const lastPeriod = !isNaN(parseFloat(props.last_period)) ? parseFloat(props.last_period) : 0

  return (
    <UI.Card paddingBottom={false} tight className='p-4'>

      <UI.VerticalList>

        <UI.Text weight='medium' size='base'>
          {props.name}
        </UI.Text>

        <UI.WithSubtitle subtitle={(
          <UI.Text uppercase size='xs'>
            <Translation name='generic.this_period' />
          </UI.Text>
        )}
        >
          <UI.Text size='base'>
            {thisPeriod.toLocaleString()}<span> </span><Translation name='economy.guest_count.visitors' />
          </UI.Text>
        </UI.WithSubtitle>

        <UI.WithSubtitle subtitle={(
          <UI.Text uppercase size='xs'>
            <Translation name='generic.last_year' />
          </UI.Text>
        )}
        >
          <UI.Text size='base'>
            {lastPeriod.toLocaleString()}<span> </span><Translation name='economy.guest_count.visitors' />
          </UI.Text>
        </UI.WithSubtitle>

      </UI.VerticalList>

    </UI.Card>
  )
}

export default React.memo(GuestCountChartTooltipInner)
